/* eslint-disable */

import IMG_LOGO_JNT from '../../assets/images/image_logo_jnt.png';
import IMG_LOGO_KRIS from '../../assets/images/image_logo_kris.png';
import IMG_LOGO_SIBB from '../../assets/images/image_logo_sibb.png';
import IMG_LOGO_MHE from '../../assets/images/IMG_LOGO_MHE.png';
import IMG_LOGO_TED from '../../assets/images/IMG_LOGO_TED.png';
import IMG_LOGO_TED_YOUTH from '../../assets/images/IMG_LOGO_TED_YOUTH.png';
import IMG_LOGO_MSU from '../../assets/images/image_logo_msu.webp';
import './LandingPartnerContent.css';

const LandingPartnerContent = () => {
  const partners = [
    { id: 1, logo: IMG_LOGO_MHE, alt: 'MHE Logo' },
    { id: 2, logo: IMG_LOGO_TED, alt: 'TED Logo' },
    { id: 3, logo: IMG_LOGO_TED_YOUTH, alt: 'TED YOUTH Logo' },
    { id: 4, logo: IMG_LOGO_SIBB, alt: 'SIBB Logo' },
    { id: 5, logo: IMG_LOGO_KRIS, alt: 'KRIS Logo' },
    { id: 6, logo: IMG_LOGO_JNT, alt: 'JNT Logo' },
    { id: 7, logo: IMG_LOGO_MSU, alt: 'MSU Logo' },
  ];

  return (
    <section className="partner-container">
      <h2 className="partner-title">รางวัลที่ได้รับ</h2>

      <div className="partner-logo-container">
        {partners.map(partner => (
          <div key={partner.id} className="partner-logo-wrapper">
            <img
              src={partner.logo}
              alt={partner.alt}
              className="partner-logo"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default LandingPartnerContent;
